// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2u1XW","colCheckbox":"styles_colCheckbox__2fdK3"};